import { SagaIterator } from "redux-saga";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { createAuditTrailReportApi } from "./api";
import { AuditTrailReportReduxTypes, CreateAuditTrailReportRequest } from "./types";

function* createAuditTrailReport({ payload }: CreateAuditTrailReportRequest): SagaIterator {
  try {
    const response = yield call(createAuditTrailReportApi, payload);
    yield put({
      type: AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT_SUCCESS,
      payload: { data: response.data.data }
    });
  } catch (error: any) {
    yield put({
      type: AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT_ERROR,
      payload: { error }
    });
  }
}

export function* watchCreateAuditTrailReport() {
  yield takeEvery(AuditTrailReportReduxTypes.AUDIT_TRAIL_REPORT, createAuditTrailReport);
}

function* auditTrailReportSaga() {
  yield all([fork(watchCreateAuditTrailReport)]);
}

export default auditTrailReportSaga;
